import { render, staticRenderFns } from "./ParentCheckboxes.vue?vue&type=template&id=04abdff1&scoped=true&"
import script from "./ParentCheckboxes.vue?vue&type=script&lang=js&"
export * from "./ParentCheckboxes.vue?vue&type=script&lang=js&"
import style0 from "./ParentCheckboxes.vue?vue&type=style&index=0&id=04abdff1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04abdff1",
  null
  
)

export default component.exports